<template>
  <v-dialog v-model="show" max-width="350px" @click:outside="noClick">
    <v-card>
      <v-card-title>
        <v-icon large right color="primary">
          mdi-comment-question-outline
        </v-icon>
      </v-card-title>
      <v-card-text>
        <div style="white-space: pre-line">{{ text }}</div>
        <v-row v-show="textField" class="my-5" dense>
          <v-text-field :label="textFieldLabel" v-model="textFieldValue" outlined></v-text-field>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click="click" :loading="loading">{{ $t("yes") }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="noClick" :loading="loading">{{ $t("no") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'AskDialog',
  props: {
    visible: Boolean,
    title: String,
    text: String,
    yes: Boolean,
    no: Boolean,
    loading: Boolean,
    textField: Boolean,
    textFieldLabel: String

  },
  data() {
    return {
      textFieldValue: ''
    }
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value)
          this.$emit('close')
      }
    }
  },
  methods: {
    click() {
      if (this.textField && this.textFieldValue == '') return;
      this.$emit('yesClick', { textFieldValue: this.textFieldValue })
    },
    noClick() {
      this.$emit('noClick')
    }

  }
}
</script>
